export default __webpack_public_path__ + "static/Business-Strategy-Development-ea8fa0547c9db002aa6c4bcc4924f5ae.webp";